export default {
  common: {
    unexpected: 'Une erreur inattendue s\'est produite',
    tryAgain: 'Veuillez réessayer plus tard',
    refresh: 'Actualiser la page'
  },
  network: {
    offline: 'Vous semblez être hors ligne',
    connectionLost: 'Connexion perdue',
    serverError: 'Erreur serveur',
    requestFailed: 'Échec de la requête'
  },
  game: {
    loadFailed: 'Échec du chargement du jeu',
    unsupported: 'Votre navigateur ne supporte peut-être pas ce jeu',
    missingDependencies: 'Composants manquants nécessaires pour exécuter le jeu'
  },
  validation: {
    required: 'Ce champ est obligatoire',
    email: 'Veuillez entrer une adresse e-mail valide',
    minLength: 'Veuillez entrer au moins {min} caractères',
    maxLength: 'Ne peut pas dépasser {max} caractères'
  }
}; 